/**
 * Folding a game title down to something a person typing on a phone can hit.
 *
 * This lives in `shared` because both catalogues have to agree. The bundled
 * index (`src/server/catalog/game-index.ts`) precomputes a key per game with it,
 * and the device's own library search (`src/client/screens/session/local.ts`)
 * applies it live — and when those two disagree, the failure is silent and
 * confusing rather than loud: the local search used a raw `includes`, so typing
 * `brass birm` found `Brass: Birmingham` in the bundled catalogue and *not* on
 * the shelf of somebody who already owned it. The server's hit was then deduped
 * away as "already in your library", leaving the manual-entry row as the only
 * offer for a game the group had played five times.
 *
 * The rules, which have to be applied identically to the query and to the title:
 * diacritics go (`Cāfe` finds `Café`), punctuation becomes a space so that
 * `brass birm` finds `Brass: Birmingham`, and runs of space collapse. `&` and `+`
 * are punctuation too — nobody types "Sherlock Holmes & Co." with the ampersand.
 */
export function normalise(text: string): string {
  return text
    .normalize("NFD")
    // Combining marks, i.e. the accents NFD just split off.
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    // Anything that is not a letter, digit or space is a separator.
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim()
    .replace(/\s+/g, " ");
}
